import { render, staticRenderFns } from "./CmsEdition.vue?vue&type=template&id=348a0d2c"
import script from "./CmsEdition.vue?vue&type=script&lang=js"
export * from "./CmsEdition.vue?vue&type=script&lang=js"
import style0 from "./CmsEdition.vue?vue&type=style&index=0&id=348a0d2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports